import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const authSuccess = authData => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    authData: authData
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};

export const logout = () => {
  localStorage.removeItem('auth');
  localStorage.removeItem('flightInfo');
  localStorage.removeItem('passengers');
  localStorage.removeItem('selectedAircraft');
  localStorage.removeItem('validTo');
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const authCheckState = () => {
  return dispatch => {
    const authData = localStorage.getItem('auth');
    if (authData) {
      const validTo = localStorage.getItem('validTo');
      if (
        validTo === null ||
        parseInt(validTo, 10) < Math.floor(Date.now() / 1000)
      ) {
        dispatch(logout());
      } else {
        dispatch(authSuccess(JSON.parse(authData)));
        localStorage.setItem('validTo', Math.floor(Date.now() / 1000) + 14400);
      }
    }
  };
};
export const auth = (email, password) => {
  return dispatch => {
    dispatch(authStart());
    const authData = {
      mail: email,
      pass: password
    };
    axiosInstance()
      .post('/users/token.json', authData)
      .then(response => {
        localStorage.setItem('auth', JSON.stringify(response.data));
        localStorage.setItem('validTo', Math.floor(Date.now() / 1000) + 14400);
        dispatch(authSuccess(response.data));
      })
      .catch(err => {
        console.log(err.response);
        dispatch(authFail(err.response.data.message));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js